/**
 * Created by Ning Jiang on 8/31/2017.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStopSpinData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {NudgeSpinReelController} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeSpinReelController";
import {BurningMReelSymbol} from "../../reelsymbol/BurningMReelSymbol";
import {WildNudgeScatterReelSymbol} from "../../reelsymbol/WildNudgeScatterReelSymbol";
import {WildNudgeParsedGameData} from "../../server/data/WildNudgeParsedGameData";

export class WildNudgeNudgeReelController extends NudgeSpinReelController {

    public static readonly START_RANDOM_FEATURE:string = "wildNudgeNudgeReelController_startRandomFeature";
    public static readonly STOP_RANDOM_FEATURE:string = "wildNudgeNudgeReelController_stopRandomFeature";

    private _burningSymbol:string = "";
    private _isWinningReel:boolean = false;
    private _stackedNudge:boolean = false;

    private _randomFeatureTriggered:boolean = false;
    private _hasWin:boolean = false;

    constructor(reelId:number) {
        super(reelId);
    }

    protected addEventListeners() {
        super.addEventListeners();

        EventHandler.addEventListener(this, WildNudgeNudgeReelController.START_RANDOM_FEATURE, (event:GameEvent) => this.startRandomFeature(event.params[0]));
        EventHandler.addEventListener(this, WildNudgeNudgeReelController.STOP_RANDOM_FEATURE, (event:GameEvent) => this.stopRandomFeature());
    }

    public onGameDataParsed(data:WildNudgeParsedGameData):void {
        super.onGameDataParsed(data);

        this._hasWin = data.betWins != null && data.betWins.length > 0;
        this._randomFeatureTriggered = data.stackedSpinTriggered;
    }

    protected parseDoNudge(data:WildNudgeParsedGameData):boolean {
        const reelNudge:boolean = (data.doReelNudge != null && data.doReelNudge[this._reelId] != null) ? data.doReelNudge[this._reelId] : false;
        const scatterNudge:boolean = (data.doScatterNudge != null && data.doScatterNudge[this._reelId] != null) ? data.doScatterNudge[this._reelId] : false;
        this._stackedNudge = (data.doReelNudge != null && data.doReelNudge[this._reelId] != null) ? data.doReelNudge[this._reelId] : false;
        this._isWinningReel = data.stackedModeSymbolInWin[this.reelId];

        return reelNudge || scatterNudge;
    }

    protected createNextSymbol(previousSymbol?:StateReelSymbol | null, init?:boolean):StateReelSymbol {
        let newSymbol:StateReelSymbol = super.createNextSymbol(previousSymbol, init);
        if(!init) {
            this.setNewSymbolFire(newSymbol);
            this.sortNewSymbolZIndex(newSymbol);
        }

        return newSymbol;
    }

    private setNewSymbolFire(newSymbol:StateReelSymbol):void {
        if(this._burningSymbol !== "" && newSymbol.stackedSymName!.isStacked && newSymbol.stackedSymName!.symName === this._burningSymbol) {
            (<BurningMReelSymbol>newSymbol).playFireOverlay(true);
            return;
        }

        if(this._gameMode === GameMode.FREESPIN && newSymbol.symName === ReelSymbolName.SCATTER) {
            (<WildNudgeScatterReelSymbol>newSymbol).playFreespinScatterAttentionOverlay();
            return;
        }
    }

    private sortNewSymbolZIndex(newSymbol:StateReelSymbol):void {
        // to make the wild fire on top of small new symbols during spinning.
        // sort low symbol on top of stacked symbol
        if(!newSymbol.stackedSymName!.isStacked) {
            for(let i:number = 0; i < 3; i++) {
                if(this._reelPartAnimator.symbolsToAnimate[i].stackedSymName!.isStacked) {
                    this.moveStackedSymbolToTop(i);
                    return;
                }
            }

            return;
        }

        // sort M symbol on top of W
        if(newSymbol.stackedSymName!.symName.charAt(0) === "M") {
            for(let i:number = 0; i < 3; i++) {
                if(this._reelPartAnimator.symbolsToAnimate[i].symName.charAt(0) === "W") {
                    this.moveStackedSymbolToTop(i);
                    return;
                }
            }
        }
    }

    private moveStackedSymbolToTop(index:number):void {
        for(let j:number = 0; j < this._reelPartAnimator.symbolsToAnimate[index].stackedSymName!.totalNum; j++) {
            const symbol:StateReelSymbol = this._reelPartAnimator.symbolsToAnimate[index + j];
            if(!symbol || !symbol.parent) {
                return;
            }
            symbol.parent.addChild(symbol);
        }
    }

    private startRandomFeature(featureSymbol:string) {
        if(this._reelId < 2) {
            return;
        }

        this._burningSymbol = featureSymbol;
    }

    private stopRandomFeature():void {
        if(this._reelId < 2) {
            return;
        }

        this._burningSymbol = "";

        this._reelView.children.forEach((child:PIXI.DisplayObject) => {
            if(child instanceof BurningMReelSymbol) {
                child.stopFireOverlay(0.5, true, true);
            }
        });
    }

    protected completeSpin():void {
        this._burningSymbol = "";

        super.completeSpin();
    }

    protected getStopDelayDelta(stopSpinData:IReelStopSpinData):number {
        let delta:number = super.getStopDelayDelta(stopSpinData);

        if(this._randomFeatureTriggered && !this._hasWin && this.reelId > 2) {
            delta *= 0.5;
        }

        return delta;
    }
}